import { render, staticRenderFns } from "./addDialog.vue?vue&type=template&id=02b9071c&scoped=true"
import script from "./addDialog.vue?vue&type=script&lang=js"
export * from "./addDialog.vue?vue&type=script&lang=js"
import style0 from "./addDialog.vue?vue&type=style&index=0&id=02b9071c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b9071c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02b9071c')) {
      api.createRecord('02b9071c', component.options)
    } else {
      api.reload('02b9071c', component.options)
    }
    module.hot.accept("./addDialog.vue?vue&type=template&id=02b9071c&scoped=true", function () {
      api.rerender('02b9071c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/setup/type/components/addDialog.vue"
export default component.exports